import { axios, axiosRetry } from '@/plugins/axios';

const base = '/bills';

export function updateAndFetchBill({ venueId, tableId, email }) {
    return axios.get(base, {
        params: {
            venueId,
            tableId,
            email
        }
    });
}

export function fetchBill({ venueId, billId, email }) {
    return axiosRetry.get(`${base}/fetch-only`, {
        params: {
            venueId,
            billId,
            email
        }
    });
}

export function payBill(payload, cfg = {}) {
    return axios.post(`${base}/pay`, payload, {
        ...cfg
    });
}

export function confirmBillSplit(payload, cfg = {}) {
    return axios.post(`${base}/split`, payload, {
        ...cfg
    });
}

export function fetchBillPayment(params, cfg = {}) {
    return axiosRetry.get(`${base}/fetch-payment`, {
        params,
        ...cfg
    });
}
